export const SET_JSON_TEMPLATE_KEYS = 'SET_JSON_TEMPLATE_KEYS';

export const setJsonTemplateKeys = (keys) => {
	return {
		type: SET_JSON_TEMPLATE_KEYS,
		payload: keys,
	};
};